import cn from "classnames"
import { ContextMenu, useContextMenu } from "components/context-menu"
import { useDialogStore } from "dialogs"
import { observer } from "mobx-react-lite"
import { useSchemeEditorStore } from "pages/scheme-editor/store"
import { useMainStore } from "store"
import useResizeObserver from "use-resize-observer"
import BlockArray from "../blocks/block-array"
import BlockConstant from "../blocks/block-constant"
import BlockGroup from "../blocks/block-group"
import BlockSelectable from "../blocks/block-selectable"
import BlockValue from "../blocks/block-value"
import { Container } from "./styled"

const BlockSystem = observer(() => {

  const mainStore = useMainStore()
  const store = useSchemeEditorStore()
  const dialog = useDialogStore()
  const { width, height, ref } = useResizeObserver()

  const contextMenu = useContextMenu(() => [
    { title: "Сохранить схему", onClick: !store.isSaved? (() => store.save(mainStore)): undefined, sub: "Ctrl+S" },
    { title: "Настройки схемы", onClick: () => dialog.open("schemaSettings", { schemaId: store.schemeId }) },
    { 
      title: (!store.showBlockKeys? "Показывать": "Не показывать") + " ключи блоков", 
      onClick: () => store.setShowBlockKeys(!store.showBlockKeys) ,
      sub: "I"
    },
  ])

  return (
    <Container 
      onMouseDown={(e) => store.onBlockSystemClick(e)} 
      onContextMenu={e => e.target === e.currentTarget && contextMenu.open(e)}
      onWheel={e => store.onWheel(e)}
      ref={ref}
      className={cn({ "create-chain": store.createChain })}
      style={{ backgroundPosition: `${-store.cameraPos.left}px ${-store.cameraPos.top}px` }}
    >
      { Array.from(store.blocks).map(([ key, blockState ]) => {
        if (blockState.type === "value") return <BlockValue key={key} state={blockState} /> 
        if (blockState.type === "array") return <BlockArray key={key} state={blockState} /> 
        if (blockState.type === "selectable") return <BlockSelectable key={key} state={blockState} /> 
        if (blockState.type === "constant") return <BlockConstant key={key} state={blockState} /> 
        if (blockState.type === "group") return <BlockGroup key={key} state={blockState} /> 
        return null
      }) }
      <svg className="svg" width={width} height={height}>
        { store.chainPaths.map((item, index) => (
          <path className="active" key={index} d={item} stroke="white" fill="transparent"/>
        ))}
      </svg>
      <ContextMenu store={contextMenu} />
    </Container>
  )
})

export default BlockSystem